module.exports = __webpack_public_path__ + "img/kehu.ca25999d.png";